<template lang="pug">
	.project-actions
		.project-edit
			.actions-button(v-pseudo-modal-show="'project-options-dropdown-' + index", @click="setTopY($event)")
				i.icons.cui-options
			.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'project-options-dropdown-' + index" :style="{top: `${topY - 25 - 204}px`}")
				.dropdown-header.text-center
					strong Actions
				.dropdown-item(@click="cloneProject")
					span Clone project
				.dropdown-item(@click="renameProject")
					span Rename project
				.dropdown-item(id="show-folders-item", :style="{'padding-right': '0px'}" @mouseover="showFolders($event.target)" @mouseout="hideFolders($event.target)")
					span(:style="{'max-width': '90%', 'pointer-events': 'none'}") Move to folder
					i.fa.fa-chevron-right
				.dropdown-item(@click="clearProjectAssetsCache")
					span Clear project assets cache


</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { User } 			from './../../services/User';
	import { Template } 		from './../../services/Template';
	import { Monitoring } 		from './../../services/Monitoring';
	import {Project} from "@/services/Project";

	export default {
		name: "ProjectActions",
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Project Changed", "Selected Project Changed"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				}
			}
		},
		props: ['index'],
		data() {

			this.User = User;
			this.Template = Template;
			this.Monitoring = Monitoring;

			this.topY = 0;

			this.copyState = {
				copy: true,
				paste: false,
				title: null
			};

			return {
				showed: true
			};

		},
		methods: {

			collectData() {

			},

			cloneProject() {

				Broadcast.call("Show Project Actions Clone");

				Broadcast.call("Pseudo Modal Hide", ["project-options-dropdown-" + this.index]);

			},

			renameProject() {

				Broadcast.call("Show Project Actions Rename");

				Broadcast.call("Pseudo Modal Hide", ["project-options-dropdown-" + this.index]);

			},

			clearProjectAssetsCache() {

				Asset.clearCompressionCache(Project.SelectedProject.id);

				Broadcast.call("Pseudo Modal Hide", ["project-options-dropdown-" + this.index]);

			},

			showFolders(target) {

				let rect = target.getBoundingClientRect();

				Broadcast.call("Show Project Actions Show Folders", [rect.left + rect.width, rect.top + rect.height / 2]);

			},

			hideFolders(target) {

				let hide = true;
				let elements = document.querySelectorAll(':hover');
				for (let i = 0; i < elements.length; i++) {
					if (elements[i].classList.contains('folders-list')) {
						hide = false;
						break;
					}
				}
				if (hide) {
					Broadcast.call("Hide Project Actions Show Folders");
				}


			},

			setTopY(event) {
				this.topY = event.clientY;
				
				this.$forceUpdate();
			}
		}
	}
</script>


<style lang="sass" scoped>


	.dropdown-menu
		right: -205px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

		.dropdown-item
			display: flex
			flex-direction: row

			i
				align-items: flex-end
				pointer-events: none
				display: flex
				padding: 0
				margin: auto 0 auto 65px

		.dropdown-item.disabled
			color: #73818f

		.icon
			margin-left: 6px

	.project-actions
		display: flex
		align-items: center
		width: 15%

		&.selected
			background-color: #20a8d8

		&:hover
			color: #23282c

		.project-edit
			padding: 0 1rem 0 0.4rem
</style>

